import {DeliveryServiceType} from '@/map/enums';

export const DEVIVERY_COMPANIES = {
  [DeliveryServiceType.baemin]: {
    label: 'A 배달앱',
    color: '#3dd3ce',
  },
  [DeliveryServiceType.coupangeats]: {
    label: 'B 배달앱',
    color: '#1e9ae3',
  },
  [DeliveryServiceType.yogiyo]: {
    label: 'C 배달앱',
    color: '#f03c51',
  },
};
